import client from '../ApolloClient'
import gql from 'graphql-tag'
import { failFetch } from '../Actions/Other'
// eslint-disable-next-line
import { Observable, Subject, filter, mergeMap, map } from 'rxjs'

import {
  FETCH_GROUPS, FETCH_PROFILES,
  loadGroups, loadProfiles
} from '../Actions/FilterLists'

const groupsQuery = gql`query allGroups($accountId: String!, $limit: Int, $offset: Int) {
    allGroups(accountId: $accountId, limit: $limit, offset: $offset){
      _id
      name
    }
  }`

/**
  * groupsEpic
  * @desc action Observer that sends a query and processes result if the action is a fetch groups action
  * @param {Observable<action>} action$ Action Observable stream
  * @return {action}
*/
export const groupsEpic = action$ =>
  action$.pipe(
    filter(action => action.type === FETCH_GROUPS),
    mergeMap(action => {
      const subject = new Subject()
      client.query({ query: groupsQuery, variables: action.query })
        .then((data) => { subject.next(data) })
        .catch((error) => {
          subject.next(error)
        })
      return subject.pipe(
        map((response) => {
          if (response.data) {
            return loadGroups(response.data)
          } else {
            return failFetch(response)
          }
        })
      )
    })
  )

const profilesQuery = gql`query allAppProfiles($accountId: String!, $limit: Int, $offset: Int) {
  allAppProfiles(accountId: $accountId, limit: $limit, offset: $offset) {
    _id
    name
    groups
  }
}`

/**
  * profilesEpic
  * @desc action Observer that sends a query and processes result if the action is a fetch profiles action
  * @param {Observable<action>} action$ Action Observable stream
  * @return {action}
*/
export const profilesEpic = action$ =>
  action$.pipe(
    filter(action => action.type === FETCH_PROFILES),
    mergeMap(action => {
      const subject = new Subject()
      client.query({ query: profilesQuery, variables: action.query })
        .then((data) => { subject.next(data) })
        .catch((error) => {
          subject.next(error)
        })
      return subject.pipe(
        map((response) => {
          if (response.data) {
            return loadProfiles(response.data)
          } else {
            return failFetch(response)
          }
        })
      )
    })
  )
